export default "__VITE_ASSET__Ct6Z3ft9__"